module.exports = __webpack_public_path__ + "media/images/dashboard/light/tile_icon_vital_stats-381f5d8c3ba30db867afecb8747caffb.png";